import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { colors } from "@constants/colors";

const LogoOnClick = () => {
  const navigator = useNavigate();

  const handleLogoClick = () => {
    navigator("/");
  };

  return (
    <ContentLogoOnClick>
      <button
        className="logo__qovis-button"
        onClick={handleLogoClick}
        aria-label="Go to home page"
        type="button"
      >
        <img
          className="logo__qovis"
          src={process.env.REACT_APP_LOGO_URL}
          alt="QOVIS Logo"
        />
      </button>
    </ContentLogoOnClick>
  );
};

export default LogoOnClick;

const ContentLogoOnClick = styled.div`
  .logo {
    &__qovis-button {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      display: inline-block;
      transition: opacity 0.2s ease;

      &:hover {
        opacity: 0.8;
      }

      &:focus {
        outline: 2px solid ${colors.blue8b4};
        outline-offset: 4px;
        border-radius: 4px;
      }

      &:focus:not(:focus-visible) {
        outline: none;
      }

      &:active {
        opacity: 0.6;
      }
    }
  }
`;
